<template>
  <section>
    <div class="flex justify-center items-center" style="height: 100vh; padding: 1.25rem !important;">
      <q-card class="my-card">
        <q-card-section align="center" class="error-icon q-pa-none">
          <!-- <q-img src="/images/auth/error-1.svg"></q-img> -->
          <q-icon name="img:/images/auth/error-2.svg"></q-icon>
        </q-card-section>

        <q-card-section align="center" class="error-title">
          Error encountered
        </q-card-section>

        <q-card-section align="center" class="error-message">
          The selected page mode is invalid.
        </q-card-section>
      </q-card>
    </div>
  </section>
</template>

<script>
export default {
  name: 'app-error-invalid-mode-page',
};
</script>

<style lang="scss" scoped>
.my-card {
  widows: 100% !important;
  max-width: 650px !important;
}
.error-icon {
  font-size: 120px;
}
.error-title {
  font-style: normal;
  font-weight: 500;
  font-size: 25px;
  line-height: 41px;
  color: #FF4B55;
}
.error-message {
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 40px;
  color: #000000;
}

@media (max-width: 1440px) {
  .error-icon {
    font-size: calc(80px + (120 - 80) * ((100vw - 320px) / (1440 - 320))) !important;
  }
  .error-title {
    font-size: calc(16px + (25 - 16) * ((100vw - 320px) / (1440 - 320))) !important;
    line-height: calc(30px + (41 - 30) * ((100vw - 320px) / (1440 - 320))) !important;
  }
  .error-message {
    font-size: calc(14px + (20 - 14) * ((100vw - 320px) / (1440 - 320))) !important;
    line-height: calc(30px + (50 - 30) * ((100vw - 320px) / (1440 - 320))) !important;
  }
}
</style>